import apiClient from './apiClient';
import {
  SchemaMigration,
  MigrationDto,
  TenantMigrationStatus,
  MigrationRunRequest,
  MigrationRunResult
} from '../types/Migration';

export const migrationApi = {
  // CRUD
  getAll: async (): Promise<SchemaMigration[]> => {
    const response = await apiClient.get<SchemaMigration[]>('/api/migration');
    return response.data;
  },

  getById: async (migrationId: string): Promise<SchemaMigration> => {
    const response = await apiClient.get<SchemaMigration>(`/api/migration/${encodeURIComponent(migrationId)}`);
    return response.data;
  },

  create: async (dto: MigrationDto): Promise<SchemaMigration> => {
    const response = await apiClient.post<SchemaMigration>('/api/migration', dto);
    return response.data;
  },

  update: async (migrationId: string, dto: MigrationDto): Promise<SchemaMigration> => {
    const response = await apiClient.put<SchemaMigration>(`/api/migration/${encodeURIComponent(migrationId)}`, dto);
    return response.data;
  },

  delete: async (migrationId: string): Promise<void> => {
    await apiClient.delete(`/api/migration/${encodeURIComponent(migrationId)}`);
  },

  // Status
  getStatus: async (): Promise<TenantMigrationStatus[]> => {
    const response = await apiClient.get<TenantMigrationStatus[]>('/api/migration/status');
    return response.data;
  },

  getTenantStatus: async (tenantId: number): Promise<TenantMigrationStatus> => {
    const response = await apiClient.get<TenantMigrationStatus>(`/api/migration/status/${tenantId}`);
    return response.data;
  },

  // Run
  run: async (request: MigrationRunRequest): Promise<MigrationRunResult> => {
    const response = await apiClient.post<MigrationRunResult>('/api/migration/run', request);
    return response.data;
  },
};

export default migrationApi;
